import { useStorage } from "app/custom-hooks/storage/useStorage";
import type { SignalType } from "app/pages/sales-intelligence/domain/signals/types/signal";
import { createStorageManager } from "app/pages/sales-intelligence/services/storage-manager/factory";

const signalsSessionStorage = createStorageManager(window.sessionStorage, (key) => `si:signals:${key}`);

/**
 * Per-type "sales request sent" flag, shared by every surface that sells a locked signal type so a request
 * made on one shows the thank-you state on all of them for the rest of the session.
 */
export const useSignalAccessRequestSent = (signalType: SignalType): readonly [boolean, VoidFunction] => {
    const { accessRequestSent } = signalsSessionStorage.configList({
        accessRequestSent: { key: `${signalType}-access-request-sent`, defaultValue: false },
    });
    const [isAccessRequestSent, setIsAccessRequestSent] = useStorage(accessRequestSent);

    const markAccessRequestSent = (): void => {
        setIsAccessRequestSent(true);
    };

    return [isAccessRequestSent, markAccessRequestSent] as const;
};
